export const COLUMN_SETTINGS = "COLUMN_SETTINGS";
